/**
 * Frontend Logger Utility
 *
 * SECURITY: All logs are DEV-ONLY
 * - import.meta.env.DEV is replaced with `false` at build time in production
 * - Vite's esbuild.drop: ['console'] removes ALL console.* from production bundle
 * - Result: Zero logs in production (physically removed, not hidden)
 */

// DEV = localhost dev server, VITE_DEBUG = deployed dev environment
const isDev = import.meta.env.DEV || import.meta.env.VITE_DEBUG === 'true';

/**
 * Creates a logger instance for a specific module
 * @param {string} moduleName - Name of the module (e.g., 'AuthContext', 'WorkflowContext')
 * @returns {Object} Logger instance with log, error, warn, info, debug methods
 */
export const createLogger = (moduleName) => {
  const prefix = `[${moduleName}]`;

  return {
    log: (...args) => {
      if (isDev) console.log(prefix, ...args);
    },

    debug: (...args) => {
      if (isDev) console.log(prefix, '[DEBUG]', ...args);
    },

    info: (...args) => {
      if (isDev) console.info(prefix, ...args);
    },

    warn: (...args) => {
      if (isDev) console.warn(prefix, ...args);
    },

    error: (...args) => {
      if (isDev) console.error(prefix, ...args);
    },

    group: (label) => {
      if (isDev) console.group(`${prefix} ${label}`);
    },

    groupEnd: () => {
      if (isDev) console.groupEnd();
    },

    table: (data) => {
      if (isDev) {
        console.log(prefix);
        console.table(data);
      }
    }
  };
};

export default createLogger;
